import { RadioField_default } from "./chunk-MC3I4LSP.js";
import { CheckableGroupComponent } from "./chunk-AUZ3GMLH.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioGroup/RadioGroup.Field.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioGroupField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent.Field, __spreadValues({
    as: RadioField_default,
    ref,
    className: clsx("pd:radio-group__field", className)
  }, rest));
});
var RadioGroup_Field_default = RadioGroupField;
export { RadioGroup_Field_default };